module.exports = __webpack_public_path__ + "static/media/noOrder.92b24fe8.svg";